import i18n from 'i18next';
import config from 'i18n-config';
import { initReactI18next } from 'react-i18next';
import { getGlobalRouter } from '@okapi/router-react';

export function initI18n() {
  const router = getGlobalRouter();
  const path = router.getPath();

  let lang = 'ru';

  if (path.startsWith('/kz/')) {
    lang = 'kz';
  }
  if (!i18n.isInitialized) {
    i18n.use(initReactI18next).init(config(lang));
  }

  if (i18n.language !== lang) {
    i18n.changeLanguage(lang);
  }
}
